import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import HTML5Backend from '@svenadlung/react-dnd-html5-mixed-backend'
import { DragDropContext } from 'react-dnd'
import { articleActions } from 'features/articles'
import Sidebar from './Sidebar'

class SidebarContainer extends PureComponent {
	render() {
		const { userProfile, ...rest } = this.props

		// const isReadOnly = userProfile.role === 100
		const userId = userProfile.id
		const workspace = userProfile.team.slug

		return (
			<Sidebar
				userId={userId}
				theme={userProfile.theme}
				logo={userProfile.team.logo}
				logoRatio={userProfile.team.logoRatio}
				logoNegative={userProfile.team.logoNegative}
				logoNegativeRatio={userProfile.team.logoNegativeRatio}
				workspace={workspace}
				isReadOnly={false}
				// isReadOnly={isReadOnly}
				{...rest}
			/>
		)
	}
}

const mapStateToProps = state => ({
	id: state.articles.article.id,
	articles: state.articles.list,
	userProfile: state.auth,
})

const mapDispatchToProps = {
	handleSubmit: articleActions.createArticleRequest,
	updateArticles: articleActions.updateArticlesRequest,
	removeArticle: articleActions.removeArticleRequest,
	changeArticleState: articleActions.changeArticleStateRequest,
	changeOutdatedState: articleActions.changeOutdatedStateRequest,
	duplicateArticle: articleActions.duplicateArticleRequest,
}

export default DragDropContext(HTML5Backend)(
	connect(mapStateToProps, mapDispatchToProps)(SidebarContainer)
)
